'use client';

import Link from 'next/link';
import { reportGoogleAdsConversion } from '../_lib/google-ads';

const CTAButton = () => {
  return (
    <Link
      href='https://app.tindlo.com/signin'
      target='_blank'
      onClick={() => reportGoogleAdsConversion()}
      className='group relative inline-flex items-center gap-2 px-9 py-[17px] rounded-full text-base font-bold text-white transition-all duration-300 overflow-hidden bg-[linear-gradient(135deg,#7c3aed,#a855f7,#22c55e)] shadow-[0_4px_20px_rgba(124,58,237,0.2)] hover:scale-105 hover:bg-[linear-gradient(135deg,hsl(263,84%,55%),hsl(271,91%,65%),hsl(20,100%,55%))] hover:shadow-[0_0_20px_4px_rgba(124,58,237,0.5),0_0_60px_8px_rgba(168,85,247,0.3),0_0_100px_16px_rgba(255,100,30,0.15)] hover:animate-btn-fire'
    >
      <span className='absolute inset-0 rounded-full pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-[radial-gradient(ellipse_at_50%_100%,rgba(255,120,0,0.35)_0%,rgba(168,85,247,0.2)_40%,transparent_70%)] animate-fire-pulse' />
      <span className='relative z-10'>Get Started Free →</span>
    </Link>
  );
};

export default CTAButton;